export default __webpack_public_path__ + "static/media/testimony.c0e16716.png";